export default {
    toastDuration: 5000,
    apiBaseUrl: `http://localhost:8001`
};